import { BusinessLineResponseDtoNameEnum } from 'libs/pinnacle-sdk';

export const BUSINESS_LINE_FOR_PRICING_MODEL: BusinessLineResponseDtoNameEnum[] =
  [
    BusinessLineResponseDtoNameEnum.Power,
    BusinessLineResponseDtoNameEnum.Property,
    BusinessLineResponseDtoNameEnum.OnshoreEnergy,
  ];
